import { string } from 'yup'
import { LanguageDTOLangKeyEnum, MasterDataDTOGenderEnum } from './generated/api'
import { Country } from './types'

export const UserValidationRules = {
    firstName: () => string().trim().required().max(50),
    lastName: () => string().trim().required().max(50),
    email: () =>
        string()
            .required()
            .email()
            .matches(/.+@.+\..+/)
            .max(100),
    companyName: () => string().trim().required().max(100),
    street: () => string().trim().required().max(100),
    houseNumber: () => string().trim().required().min(1).max(5),
    postalCode: () => string().trim().required().max(15),
    city: () => string().trim().required().max(60),
    telephone: () => string().trim().required().max(20),
    password: () =>
        string()
            .required()
            .min(8)
            .matches(/[A-Z]/)
            .matches(/[a-z]/)
            .matches(/[0-9]/)
            .matches(/[@$!%*#?&]/),
    genders: () => string().oneOf(Object.values(MasterDataDTOGenderEnum)).required(),
    language: () => string().oneOf(Object.values(LanguageDTOLangKeyEnum)).required(),
    country: () => string().oneOf(Object.values(Country)).required(),
}

export const MAX_FILE_SIZE_BYTES = 5242880
